module.exports = __webpack_public_path__ + "static/img/p4_5.431d235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/p4_5.png
// module id = 0AKP
// module chunks = 0